import React, { useCallback, forwardRef, type Ref } from 'react';
import AddIcon from '@atlaskit/icon/core/add';
import { IconButton, type IconButtonProps } from '@atlaskit/button/new';

import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type Props = {
	onClick?: () => void;
	isCreateWorkItem?: boolean;
	renderIcon?: IconButtonProps['icon'];
};

const getWorkItemMessage = () =>
	fg('jira-issue-terminology-refresh-m3') ? messages.createWorkItem : messages.createIssue;

const CreateChildButton = forwardRef(
	({ onClick, isCreateWorkItem, renderIcon }: Props, ref: Ref<HTMLButtonElement>) => {
		const { formatMessage } = useIntl();

		const defaultIcon: IconButtonProps['icon'] = useCallback(
			(iconProps) => <AddIcon {...iconProps} size="small" />,
			[],
		);

		return (
			<IconButton
				spacing="compact"
				appearance="subtle"
				label={
					isCreateWorkItem
						? formatMessage(getWorkItemMessage())
						: formatMessage(messages.createChildItem)
				}
				testId="issue-table-hierarchy.ui.create-child-button.create"
				icon={
					renderIcon && fg('jira_list_merged_column_inline_create_icon_style')
						? renderIcon
						: defaultIcon
				}
				onClick={onClick}
				isTooltipDisabled={false}
				ref={ref}
			/>
		);
	},
);

export default CreateChildButton;
